const TokenKey = 'Admin-Data';

export function getToken() {
  return localStorage.getItem(TokenKey) || '{}'
}

export function setToken(token) {
  localStorage.setItem('loginTime', new Date().getTime()+'');
  return localStorage.setItem(TokenKey, token)
}

export function removeToken() {
  localStorage.setItem('loginTime', '');
  return localStorage.setItem(TokenKey,'')
}

export function getSession() {
  const user = JSON.parse(localStorage.getItem(TokenKey));
  return !!user && user.userId;
}

export function getValue(key) {
    const user = JSON.parse(localStorage.getItem(TokenKey));
    return !!user && user[key];
}

export function getPrjInfo(key) {
  var projectInfo = JSON.parse(sessionStorage.getItem('projectInfo'))
  if (projectInfo && projectInfo.hasOwnProperty('mainPrjCode')) {
    const obj = {}
    obj.prjId = projectInfo.projectId
    obj.prjCode = projectInfo.mainPrjCode
    obj.sectionId = projectInfo.mainSectionId
    obj.sectionCode = projectInfo.mainSectionCode
    obj.mainPrjCode = projectInfo.mainPrjCode
    obj.prjName = projectInfo.mainPrjName
    return obj[key]
  }
  return null
}



// WEBPACK FOOTER //
// ./src/api/bjca/auth.js